<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
<script>
    import router from './router';
    export default {
        created() {
            var userObj = localStorage.getItem('user');
            let url = window.location.href;
            if(url.indexOf("downloadAttachment")!=-1){
                return;
            }
            if(!userObj && to.path != "/portalLogin") {
                localStorage.clear();
				let url = "/login";
				if(location.href.indexOf('?') != -1) {
					url += "?"+location.href.substring(location.href.indexOf('?')); //获取url中"?"符后的字串
				}
                router.push(url);
            }
            this.$router.beforeEach((to, from, next) => {
                var routearr = localStorage.getItem("routearr");
                if(to.path == "/login" || (from.path == '/archivesRetrieval' && to.path == "/archivesRetrievalFuzzySearch")) {
                    next();
                } else {
                    if((routearr && routearr.indexOf(to.meta.index[0])) == -1) {
                        next(from.path);
                    } else {
                        next();
                    }
                }
            });
        }
    }
</script>
<style>
    @import "./assets/css/main.css";
    @import "./assets/css/color-dark.css";     /*深色主题*/
    /*@import "./assets/css/theme-green/color-green.css";   浅绿色主题*/
</style>